import { Components } from "@thisgorilla/primate-ds";
import { useState } from "react";
import styled, { useTheme } from "styled-components";
import { formatNumberToK } from "../../../../../utils";

type CounterProps = {
  title: string;
  count: number;
  onClick: () => void;
};
export const Counter = ({ title, count, onClick }: CounterProps) => {
  const { typography, Color } = useTheme();
  const [isHovered, setHovered] = useState(false);
  const textColor = isHovered
    ? Color.text["text-emphasize-brand-bolder"].value
    : undefined;

  return (
    <Container
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={onClick}
    >
      <Components.Text
        text={title}
        style={{ tokenStyle: typography.Heading.XXS }}
        fontWeight="font-weight-semibold"
        color={textColor}
        isunderlined={isHovered}
      />
      <Components.Counter
        color="Dark"
        kind="Fill"
        count={formatNumberToK(count)}
        size="Small"
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: ${({ theme }) => theme.spacing["spacing-8"].value}rem;
  box-sizing: border-box;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  border-radius: ${({ theme }) => theme.radius["radius-xxs"].value}rem;
  cursor: pointer;
  &:hover {
    background: ${({ theme }) =>
      theme.Color.elevation.surface["surface-primary-emphasize-hover"].value};
  }
`;
